import { Box, ImageList, ImageListItem, Link, Typography } from '@mui/material'
import React, { useEffect } from 'react'
import useSWR from 'swr'
import { formatUnixTimeStampToDate } from '~/src/libs'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'

import { orderRepository } from '~/src/repositories'
import { LoadingNormal } from '~/src/components/organisms'
import { useMessage } from '~/src/hooks'

type TFile = {
  filename?: string
  url?: string
}

type MessageProps = {
  id: number
  name: string
  message: string
  user?: { id: number; name: string }
  admin?: { id: number; name: string }
  attachedFiles?: TFile[] | []
  createdAt: string
}

interface IOrdersItemProps {
  id: number
  item: {
    id: number
    displayName: string
    refNo: string
    isKanazawaLocation: boolean
  }
  createdAt: string
  updatedAt: string
  user: { id: number; email: string }
  year?: number
}

interface DashBoardOrdersMessageProps {
  id: string
  item: IOrdersItemProps
  messages: MessageProps[]
}

/**
 * NewContactOrders
 */
export const NewContactOrders: React.FC = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const location = useLocation()
  const { handleOpenWithErrorMessage } = useMessage()

  const { data: ordersMessages, error } = useSWR(['/request-orders/messages'], () =>
    orderRepository.requestDashBoardOrdersMessage()
  )

  useEffect(() => {
    if (error) handleOpenWithErrorMessage(error.message)
  }, [error])

  if (!ordersMessages) return <LoadingNormal />

  // @ts-ignore
  const { data } = ordersMessages
  const ordersMessagesSize = data.length ? data.length - 1 : 0

  if (ordersMessagesSize < 0) {
    return (
      <Box m={2}>
        <Typography
          sx={{
            fontFamily: 'Roboto',
            fontStyle: 'normal',
            fontWeight: 400,
            fontSize: '16px',
            lineHeight: '16px',
            color: '#222222',
          }}
        >
          {t('dashboard.no_new_exchanges')}
        </Typography>
      </Box>
    )
  }

  return data?.map((item: DashBoardOrdersMessageProps, index: number) =>
    item.messages.length > 0
      ? item.messages.map((message, i: number) => (
          <Box
            sx={{
              padding: '16px',
              boxShadow: 'inset 0px -1px 0px rgba(0, 0, 0, 0.12)',
            }}
            key={i}
          >
            {/*
            <Box>{item.item.id}</Box>
            <Box>{message.id}</Box >*/}

            <Typography
              sx={{
                fontFamily: 'Roboto',
                fontStyle: 'regular',
                fontSize: '14px',
                lineHeight: '18.2px',
                color: '#222222',
                marginBottom: '20px',
              }}
            >
              {message.user ? message.user.name : message.admin ? message.admin.name : ''}
            </Typography>

            <Box>{message.message}</Box>

            {message?.attachedFiles && message.attachedFiles.length > 0 && (
              <ImageList sx={{ width: 160, height: 60 }} cols={2} gap={8}>
                {message?.attachedFiles?.map((file, ind) => {
                  return (
                    file.url && (
                      <ImageListItem key={ind}>
                        <img src={file.url} alt={file.filename} loading="lazy" />
                      </ImageListItem>
                    )
                  )
                })}
              </ImageList>
            )}

            <Box
              sx={{
                fontFamily: 'Roboto',
                fontStyle: 'normal',
                fontWeight: 400,
                fontSize: '12px',
                lineHeight: '20px',
                letterSpacing: '0.4px',
                mb: '20px',
                mt: '20px',
              }}
            >
              <Link
                color="#3F51B5"
                onClick={() =>
                  navigate(`/admin/order/contact-order/detail/${item?.item.id}`, {
                    state: {
                      prevLocationState: { ...location },
                    },
                  })
                }
                sx={{
                  cursor: 'pointer',
                }}
              >
                {t('dashboard.view_negotiation_details')}
              </Link>

              <Box>
                {formatUnixTimeStampToDate(
                  message.createdAt as unknown as number,
                  'yyyy/MM/dd h:mm:ss'
                )}
              </Box>
            </Box>
          </Box>
        ))
      : null
  )
}
